import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_2/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/FourtuneWheel/1_1x.png`;
const Pic2 = `${FullPath}/FourtuneWheel/2_1x.png`;
const Pic3 = `${FullPath}/FourtuneWheel/3_1x.png`;
const Pic4 = `${FullPath}/FourtuneWheel/4_1x.png`;
const Pic5 = `${FullPath}/FourtuneWheel/5_1x.png`;
const Pic6 = `${FullPath}/FourtuneWheel/6_1x.png`;
const Pic7 = `${FullPath}/FourtuneWheel/7_1x.png`;
const Pic8 = `${FullPath}/FourtuneWheel/8_1x.png`;
const Pic9 = `${FullPath}/FourtuneWheel/9_1x.png`;
const Pic10 = `${FullPath}/FourtuneWheel/10_1x.png`;
const Pic11 = `${FullPath}/FourtuneWheel/11_1x.png`;
const Pic12 = `${FullPath}/FourtuneWheel/12_1x.png`;
const Pic13 = `${FullPath}/FourtuneWheel/13_1x.png`;
const Pic14 = `${FullPath}/FourtuneWheel/14_1x.png`;
const Pic15 = `${FullPath}/FourtuneWheel/15_1x.png`;
const Pic16 = `${FullPath}/FourtuneWheel/16_1x.png`;
const Pic17 = `${FullPath}/FourtuneWheel/17_1x.png`;
const Pic18 = `${FullPath}/FourtuneWheel/18_1x.png`;
const Pic19 = `${FullPath}/FourtuneWheel/19_1x.png`;
const Pic20 = `${FullPath}/FourtuneWheel/20_1x.png`;
const Pic21 = `${FullPath}/FourtuneWheel/21_1x.png`;
const Pic22 = `${FullPath}/FourtuneWheel/22_1x.png`;
const Pic23 = `${FullPath}/FourtuneWheel/23_1x.png`;
const Pic24 = `${FullPath}/FourtuneWheel/24_1x.png`;
const Pic25 = `${FullPath}/FourtuneWheel/25_1x.png`;
const Pic26 = `${FullPath}/FourtuneWheel/26_1x.png`;
const Pic27 = `${FullPath}/FourtuneWheel/27_1x.png`;
const Pic28 = `${FullPath}/FourtuneWheel/28_1x.png`;
const Pic29 = `${FullPath}/FourtuneWheel/29_1x.png`;
const Pic30 = `${FullPath}/FourtuneWheel/30_1x.png`;
const Pic31 = `${FullPath}/FourtuneWheel/31_1x.png`;
const Pic32 = `${FullPath}/FourtuneWheel/32_1x.png`;
const Pic33 = `${FullPath}/FourtuneWheel/33_1x.png`;
const Pic34 = `${FullPath}/FourtuneWheel/34_1x.png`;
const Pic35 = `${FullPath}/FourtuneWheel/35_1x.png`;
const Pic36 = `${FullPath}/FourtuneWheel/36_1x.png`;
const Pic37 = `${FullPath}/FourtuneWheel/37_1x.png`;
const Pic38 = `${FullPath}/FourtuneWheel/38_1x.png`;
const Pic39 = `${FullPath}/FourtuneWheel/39_1x.png`;
const Pic40 = `${FullPath}/FourtuneWheel/40_1x.png`;
const Pic41 = `${FullPath}/FourtuneWheel/41_1x.png`;




export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
        Pic20,
        Pic21,
        Pic22,
        Pic23,
        Pic24,
        Pic25,
        Pic26,
        Pic27,
        Pic28,
        Pic29,
        Pic30,
        Pic31,
        Pic32,
        Pic33,
        Pic34,
        Pic35,
        Pic36,
        Pic37,
        Pic38,
        Pic39,
        Pic40,
        Pic41,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}